(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-scroll-campaign"] && !Shopify.designMode) return;
  try {
    
  const panels = document.querySelectorAll('.blv-scroll-panel');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.target.classList.toggle('is-visible', entry.isIntersecting));
    }, { threshold: .22 });
    panels.forEach(panel => observer.observe(panel));
  } else {
    panels.forEach(panel => panel.classList.add('is-visible'));
  }
  const campaign = document.querySelector('.blv-scroll-campaign');
  if (campaign) {
    let scrollUpdateQueued = false;
    const updateCampaignBoundary = () => {
      document.documentElement.classList.toggle('blv-campaign-ended', campaign.getBoundingClientRect().bottom <= window.innerHeight);
      scrollUpdateQueued = false;
    };
    const scheduleCampaignBoundary = () => {
      if (scrollUpdateQueued) return;
      scrollUpdateQueued = true;
      requestAnimationFrame(updateCampaignBoundary);
    };
    window.addEventListener('scroll', scheduleCampaignBoundary, { passive: true });
    window.addEventListener('resize', scheduleCampaignBoundary);
    updateCampaignBoundary();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-blv-cart-form]').forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') return;

      event.preventDefault();

      var updateButton = form.querySelector('[data-blv-cart-update]');
      if (updateButton) updateButton.disabled = true;

      try {
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: new FormData(form)
        });

        var result = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Could not update your bag.');
        }

        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.assign(form.dataset.fallbackUrl || root);
        }
      } catch (error) {
        if (updateButton) updateButton.disabled = false;
        window.alert(error.message);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initGallery(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    var photos=Array.from(root.querySelectorAll('.blv-compact-photo'));
    if(!photos.length)return;
    var thumbs=Array.from(root.querySelectorAll('.blv-compact-thumbnail'));
    var dialog=root.querySelector('.blv-gallery-dialog'),enlarged=dialog.querySelector('img');
    var current=0,opener=null,previousOverflow='';
    function select(index,scrollThumb){
      current=(index+photos.length)%photos.length;
      photos.forEach(function(photo,i){photo.hidden=i!==current});
      thumbs.forEach(function(thumb,i){thumb.setAttribute('aria-pressed',String(i===current))});
      if(scrollThumb&&thumbs[current]){
        var rail=thumbs[current].parentElement,thumb=thumbs[current];
        rail.scrollTo({left:thumb.offsetLeft-rail.offsetLeft-rail.clientWidth/2+thumb.clientWidth/2,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      if(dialog.open){
        var img=photos[current].querySelector('img');
        enlarged.src=img.src;enlarged.alt=img.alt;
        dialog.querySelector('[data-gallery-current]').textContent=current+1;
      }
    }
    function selectMedia(id){
      var index=photos.findIndex(function(photo){return photo.dataset.mediaId===String(id)});
      if(index>=0)select(index,true);
    }
    root.blvSelectMedia=selectMedia;selectMedia(root.dataset.initialMedia);
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){select(i,false)})});
    photos.forEach(function(photo,i){photo.addEventListener('click',function(){
      opener=photo;previousOverflow=document.documentElement.style.overflow;
      dialog.showModal();document.documentElement.style.overflow='hidden';select(i,false);
    })});
    dialog.querySelector('[data-gallery-close]').addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('close',function(){document.documentElement.style.overflow=previousOverflow;if(opener)opener.focus({preventScroll:true})});
    var prev=dialog.querySelector('[data-gallery-prev]'),next=dialog.querySelector('[data-gallery-next]');
    if(prev)prev.addEventListener('click',function(){select(current-1,true)});
    if(next)next.addEventListener('click',function(){select(current+1,true)});
    dialog.addEventListener('keydown',function(event){
      if(event.key==='ArrowLeft'){event.preventDefault();select(current-1,true)}
      if(event.key==='ArrowRight'){event.preventDefault();select(current+1,true)}
    });
    var surface=dialog.querySelector('[data-gallery-enlarged]'),start=null;
    surface.querySelector('img').addEventListener('dragstart',function(event){event.preventDefault()});
    surface.addEventListener('pointerdown',function(event){if(event.pointerType==='touch'){start={x:event.clientX,y:event.clientY};surface.setPointerCapture(event.pointerId)}});
    surface.addEventListener('pointerup',function(event){
      if(!start)return;var dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))select(current+(dx<0?1:-1),true);
    });
    surface.addEventListener('pointercancel',function(){start=null});
    root.addEventListener('blv:gallery:variant',function(event){if(event.detail&&event.detail.mediaId)selectMedia(event.detail.mediaId)});
    if(root.dataset.pendingMedia)selectMedia(root.dataset.pendingMedia);
  }
  function init(scope){scope.querySelectorAll('[data-blv-compact-gallery]').forEach(initGallery)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
